export default __webpack_public_path__ + "static/media/community-ai-art-icon.c217672e.png";